let storeListGlobal;
let qstText;
// second call to update modal content with selected template data
const handleModalBodyQuestions = (event) => {
    const deviceType = $('body').hasClass("mobilePage") ? 'mobile' : $('body').hasClass('tabletPage') ? 'tablet' : 'desktop';
    const userEmail = $('#displayEmail').text().split(':')
    
    let quantumMetricSessionId = document.cookie.match('QuantumMetricSessionID' + '=(.*?)(;|$)');
    quantumMetricSessionId = (quantumMetricSessionId) ? unescape(quantumMetricSessionId[1]) : undefined;
    if (quantumMetricSessionId) {
        document.getElementById('QuantumMetricSessionID').value = quantumMetricSessionId;
    }
	$.ajax({
		url: '/wcs/resources/store/301/survey/template/8af8c471-7f38-4644-873e-ac780a97b096',
		type: 'GET',
		dataType: 'json',
		success: function (json) {
            let newTemplate = json.response;
            document.getElementById('templateId').value = newTemplate.templateId;
            document.getElementById('version').value = newTemplate.version;
            if (newTemplate !== undefined) {
                let newContent = '';
                let questions = newTemplate.questions;
                for (let x = 0; x < questions.length; x++) {
                    let question = questions[x];
                    if (question.type === 'LONG') {
                        let questionText = question.text;
                        let isRequired = question.required === true ? 'required' : 'optional';
                        newContent += `<div id="feedbackMessageLong" class="feedback-form-group">
                                            <label for="feedback_textarea" class="sr-only">Enter your message${isRequired === 'required' ? '*' : ''}</label>
                                            <textarea id="feedback_textarea" data-validate  class="form-control feedback-form-data" data-validate="" value placeholder="${questionText}${isRequired === 'required' ? '*' : ''}" name="feedback_textarea" maxlength="1000" aria-describedby="" ${isRequired}></textarea>
                                            <div id="characterCounter" class=""><span id="charCountLong">1000 characters remaining</span></div>
                                            <p hidden class="required feedback-error-message">This field is required</p>
                                        </div>
                                        `
                    }
                    if (question.type === 'SHORT') {
                        let questionText = question.text;
                        let isRequired = question.required === true ? 'required' : 'optional';
                        newContent += `<div id="feedbackMessageShort" class="feedback-form-group">
                                            <label for="feedbackTextAreaShort" class="sr-only">Enter your message</label>
                                            <input id="feedbackTextAreaShort" data-validate  class="form-control feedback-form-data feedback-short-ans" value placeholder="${questionText}${isRequired === 'required' ? '*' : ''}" name="feedbackTextAreaShort" maxlength="200" aria-describedby="" ${isRequired}></input>
                                            <div id="characterCounter" class=""><span id="charCountShort">200 characters remaining</span></div>
                                            <p hidden class="required feedback-error-message">This field is required</p>
                                        </div>
                                        `
                    }
                    if (question.type === 'OPT') {
                        let questionText = question.text;
                        let isRequired = question.required === true ? 'required' : 'optional';
                        let questionId = question.questionId;
                        let questionOptions = question.questionOptions;
                        newContent += `<div id="feedbackOptions" class="feedback-form-group">
                                        <label for="feedbackOptionSelect" class="sr-only">Please make a selection</label>
                                        <select id="feedbackOptionSelect" key-selector="${questionId}" data-validate  class="form-control feedback-form-data feedback-options" value name="feedbackOptionSelect" ${isRequired}>
                                            <option value="" selected disabled>${questionText}${isRequired === 'required' ? '*' : ''}</option>`
                                            for (let x = 0; x < questionOptions.length; x++) {
                                                let option = document.createElement('option');
                                                option.innerHTML = questionOptions[x].value;
                                                option.value = questionOptions[x].value;
                                                newContent += option.outerHTML;
                                            }
                        newContent += `</select>
                                    <p hidden class="required feedback-error-message">This field is required</p>
                                    </div>
                                    `
                    }
                    if (question.type === 'NY') {
                        let questionText = question.text;
                        let isRequired = question.required === true ? 'required' : 'optional';
                        newContent += `<div id="formActions" class="feedback-form-group" ${isRequired}>
                                            <input type="hidden" id="yesNoFeedbackFormInput" key-selector="${x}" data-validate  class="feedback-form-data" name="noYesFeedbackFormInput_${x}" value="" ${isRequired}>
                                            <p>${questionText}${isRequired === 'required' ? '*' : ''}</p>
                                            <button name='yOn' type="button" id="yes" key-selector="${x}" class="btn btn-secondary yesOrNoButton ${x}" value='N'>No</button>
                                            <button name='yOn' type="button" id="no" key-selector="${x}" class="btn btn-secondary yesOrNoButton ${x}" value='Y'>Yes</button>
                                            <p hidden class="required feedback-error-message">This field is required</p>    
                                        </div>
                                        `
                    }
                    if (question.type === 'YN') {
                        let questionText = question.text;
                        let isRequired = question.required === true ? 'required' : 'optional';
                        newContent += `<div id="formActions" class="feedback-form-group" ${isRequired}>
                                            <input type="hidden" id="yesNoFeedbackFormInput" key-selector="${x}" data-validate class="feedback-form-data" name="yesNoFeedbackFormInput_${x}" value="" ${isRequired}>
                                            <p>${questionText}${isRequired === 'required' ? '*' : ''}</p>
                                            <button name='yOn' type="button" id="yes" key-selector="${x}" class="btn btn-secondary yesOrNoButton ${x}" value='Y'>Yes</button>
                                            <button name='yOn' type="button" id="no" key-selector="${x}" class="btn btn-secondary yesOrNoButton ${x}" value='N'>No</button>
                                            <p hidden class="required feedback-error-message">This field is required</p>
                                        </div>
                                        `
                    }
                    if (question.type === 'STAR') {
                        let questionText = question.text;
                        let isRequired = question.required === true ? 'required' : 'optional';
                        newContent += `<div id="feedbackRating" class="feedback-form-group" ${isRequired}>
                                            <input type="hidden" id="starRating" data-validate class="feedback-form-data" name="starRating" value="" ${isRequired}>
                                            <p class="feedback_text" id="star_text">${questionText}${isRequired === 'required' ? '*' : ''}</p>
                                            <button class="star_rating_button" type='button'>
                                                <span class="feedbackStar star-1" data-star="1">&#9733;</span>
                                            </button>
                                            <button type='button' class="star_rating_button">
                                                <span class="feedbackStar star-2" data-star="2">&#9733;</span>
                                            </button>
                                            <button type='button' class="star_rating_button">
                                                <span class="feedbackStar star-3" data-star="3">&#9733;</span>
                                            </button>
                                            <button type='button' class="star_rating_button">
                                                <span class="feedbackStar star-4" data-star="4">&#9733;</span>
                                            </button>
                                            <button type='button' class="star_rating_button">
                                                <span class="feedbackStar star-5" data-star="5">&#9733;</span>
                                            </button>
                                            <p class="feedback_text">1 = poor, 5 = excellent</p>
                                            <p hidden class="required feedback-error-message">This field is required</p>
                                        </div>
                                        `
                    }
                    if (question.type === 'EMAIL') {
                        let questionText = question.text;
                        let isRequired = question.required === true ? 'required' : 'optional';
                        newContent += `<div id="feedbackEmail" class="feedback-form-group">
                                            <label for="feedbackEmailInput" class="sr-only">Please enter an email address${isRequired === 'required' ? '*' : ''}</label>
                                            <input type="email" id="feedbackEmailInput" data-validate class="form-control feedback-form-data" data-validate="email" name="feedbackEmailInput" value="${userEmail[1] ? userEmail[1] : ''}" placeholder="${deviceType === 'desktop' ? questionText : 'Please enter your contact email'}" maxlength="50" ${isRequired}>
                                            <p hidden class="required feedback-error-message">This field is required</p>
                                        </div>
                                        `
                    }
                    if (question.type === 'STORE') {
                        const questionText = question.text;
                        const isRequired = question.required === true ? 'required' : 'optional';
                        const allStores = question.storeList;
                        const stateList = []
                        storeListGlobal = allStores;
                        qstText = questionText;
                        allStores.length && allStores.forEach((store) => {
                            if (!stateList.includes(store.stateName)) {
                                stateList.push(store.stateName);
                            }
                        });


                        newContent += `<div id="feedbackStoreLocationSelect">
                                        <div class="feedback-form-group">
                                        <label for="feedbackStateSelect" class="sr-only">Please select a state</label>
                                        <select type='state' id="feedbackStateSelect" class="form-control feedback-form-data location" name="feedbackStateSelect" value='' ${isRequired}>
                                            <option value="*" selected hidden disabled>Select a state${isRequired === 'required' ? '*' : ''}</option>`
                                            stateList.forEach((a) => {
                                                newContent += `<option value="${a}">${a}</option>`;
                                            })
                        newContent += `</select>
                                        <p hidden class="required feedback-error-message">This field is required</p>
                                        </div>
                                        `
                        newContent += `<div class="feedback-form-group" id='select-store-type' hidden>
                                        <label for="feedbackStoreSelect" class="sr-only">Please select a store${isRequired === 'required' ? '*' : ''}</label>
                                        <select type='store' id="feedbackStoreSelect" class="form-control feedback-form-data location" name="feedbackStoreSelect" value='' ${isRequired}>`
                        newContent += `</select>
                                        <p hidden class="required feedback-error-message">This field is required</p>
                                        </div>
                                        
                                    </div>`
                    }
                }
                // inserting new content into modal
                let newContentNode = document.createElement('div');
                newContentNode.id = 'responseContent';
                newContentNode.innerHTML = newContent;
                let oldContentNode = document.getElementById('responseContent');
                oldContentNode.parentNode.replaceChild(newContentNode, oldContentNode);
                listenForStateSelectChange();
                countCharacters();
                handleStarRating();
                handleYesNos();
                listenForStoreSelectChange();
                listenForInput();
                listenForOptionsSelect();
                listenForOpenClose();
            }
		},
		error: function (json) {
			$('#dynamicModalContainer').modal('hide');
		},
	});
};


const listenForContinueShoppingButton = () => {
    const continueButton = document.getElementById("feedback-continue-shopping")
    if (continueButton) {
        continueButton.addEventListener('click', closePostPurchaseModal)
    }
}

const initialView = `<div id="postPurchaseModalStatic">
                        <div id="feedbackLogo"><img src="/assets/img/logos/dillard-logo.svg" alt="Dillard's Logo" width="136" height="30"></div>
                        <div id="feedbackTopic" class="feedback-form-group">
                            <p id='feedback_blurb'>We are always looking for ways to improve your experience. Please tell us what you think that could make shopping at Dillard's even better.</p>
                        </div>
                        <input type="hidden" class="feedback-form-data meta-data" id="templateId" name="templateId" value="">
                        <input type="hidden" class="feedback-form-data meta-data" id="version" name="version" value="">
                        <input type="hidden" class="feedback-form-data meta-data" id="QuantumMetricSessionID" name="QuantumMetricSessionID" value="">
                        <form id="feedbackForm">
                            <div id="responseContent"></div>
                        
                            <div id="formActions" class="feedback_buttons_section">
                                <button type="button" id="close-feedback-modal" class="btn btn-secondary form-control" data-dismiss="modal">Cancel</button>
                                <button type="button" onclick class="btn btn-primary form-control oneClickOnly clickSubmit" id="submit-feedback-form">Submit</button>
                            </div>
                        </form>
                    </div>`;

// first call for feedback template - builds select dropdown
const postPurchaseModal = (params, returnHTML) => {
        
        let newContentNode = document.createElement('div');
        newContentNode.innerHTML = initialView;
        returnHTML(initialView)
        listenForContinueShoppingButton();
        handleModalBodyQuestions();
        handleSubmitButton();

          
    $('#dynamicModalContainer').addClass('feedback-modal');
    $('.modal-dialog').addClass('feedback-modal-dialog');
    $('.modal-content').addClass('feedback-modal-content');
    $('.modal-header').addClass('feedback-modal-header');
    
}

const listenForOpenClose = () => {
    if (document.getElementById("close-feedback-modal")) {
        document.getElementById('close-feedback-modal').addEventListener('click', closePostPurchaseModal);
    }
    if (document.getElementById("feedback-continue-shopping")) {
        document.getElementById("feedback-continue-shopping").addEventListener('click', closePostPurchaseModal)
    }
}



const closePostPurchaseModal = (e) => {
    e.preventDefault();
    $('#dynamicModalContainer').modal('hide');
}




// ---------------
// -----STATE-----
//
// handle showing the appropriate optgroup based on selected state name
const listenForStateSelectChange = () => {
   
	if (document.getElementById('feedbackStateSelect')) {
		document.getElementById('feedbackStateSelect').addEventListener('change', showSelectedOptgroup);
	}
};

// dynamically build option list based on state selection
const showSelectedOptgroup = (event) => {
    const errElm = $('#feedbackStateSelect').siblings('.feedback-error-message')[0]; 
    $('#feedbackStateSelect').parent().removeClass('has-error');
    errElm.setAttribute('hidden', '');
    if ($('#feedbackStateSelect').val()) {
        $('#select-store-type').removeAttr('hidden')
    }

    $('#feedbackStoreSelect').not(':first').empty();

    let selectedState = event.target.value;
    
    const storesOfSelectedState = storeListGlobal.filter((a) => {
        return a.stateName === selectedState;
    })

    const dirtyAreas = [];
    storesOfSelectedState.length && storesOfSelectedState.forEach((store) => {
        if (!dirtyAreas.includes(store.marketTag)) {
            dirtyAreas.push(store.marketTag)
        }
    });

    const storesDropdown = document.getElementById('feedbackStoreSelect')
    const cleanAreas = (word) => {
        if (word.includes('\|')) {
        return word.substring(0, word.indexOf('\|'));
        } else return word;
    };

    let optionList = `<option value="*" selected hidden disabled>${qstText}${'*'}</option>`;
    
    dirtyAreas.forEach((a) => {
        let optGrp = `<optgroup label="${cleanAreas(a)}">`;

        storesOfSelectedState.map((b) => {
            if (b.marketTag.includes(a)) {
                optGrp += `<option class="${b.stateName} select-location-option" value="${b.identifier}">${b.name}</option>`;
            }
        });
        
        optGrp += `</optgroup>`;
        optionList += optGrp;
    })

    storesDropdown.innerHTML = optionList;
    
};
// -------------
// -------------



// -------------
// ----STORE----
//
// listen for change on store select option
const listenForStoreSelectChange = () => {
    if (document.getElementById('feedbackStoreSelect')) {
		document.getElementById('feedbackStoreSelect').addEventListener('change', handleStoreErrors);
	}
}

// remove errors on select change
const handleStoreErrors = () => {
    const errElm = $('#feedbackStoreSelect').siblings('.feedback-error-message')[0]; 
    errElm.setAttribute('hidden', '');
    $('#feedbackStoreSelect').parent().removeClass('has-error');
}
//---------------
// --------------


// listen for input on short answers to remove errors
const listenForInput = () => {
    const shortAns = document.getElementsByClassName('feedback-short-ans');

    if (shortAns) {
        for (let i = 0; i < shortAns.length; i++) {
            if (shortAns[i] !== undefined) {
                shortAns[i].addEventListener('input', handleInputErrors);
            }
        }
	}
}

const handleInputErrors = (e) => {
    const currElm = e.target;
    $(currElm).parent().removeClass("has-error");
    const errElm = $(currElm).siblings(".feedback-error-message")[0];
    errElm.setAttribute('hidden', '')
}


// listen to select change for options 
const listenForOptionsSelect = () => {
    const options = document.getElementsByClassName('feedback-options');

    if (options) {
        for (let i = 0; i < options.length; i++) {
            if (options[i] !== undefined) {
                options[i].addEventListener('change', handleOptionsErrors);
            }
        }
	}
}

const handleOptionsErrors = (e) => {
    const currElm = e.target;
    $(currElm).parent().removeClass("has-error");
    const errElm = $(currElm).siblings(".feedback-error-message")[0];
    errElm.setAttribute('hidden', '')
}


// star rating - get the selected value and update the hidden input's value
const handleStarRating = () => {
    let allStars = document.querySelectorAll('.feedbackStar');
    const errElm = $('#feedbackRating').children('.feedback-error-message')[0];

    let x = 0;
    while (x < allStars.length) {
        allStars[x].addEventListener('click', function () {
            errElm.setAttribute('hidden', '');
            let currentStar = parseInt(this.getAttribute('data-star'));
            document.getElementById('starRating').value = currentStar;
            let precedingStar = currentStar;
            while (1 <= precedingStar) {
                if (!document.querySelector('.star-' + precedingStar).classList.contains('is-active')) {
                    document.querySelector('.star-' + precedingStar).classList.add('is-active');
                }
                --precedingStar;
            }
            let succeedingStar = currentStar + 1;
            while (5 >= succeedingStar) {
                if (document.querySelector('.star-' + succeedingStar).classList.contains('is-active')) {
                    document.querySelector('.star-' + succeedingStar).classList.remove('is-active');
                }
                ++succeedingStar;
            }
        });
        x++;
    }
}

const countCharacters = () => {
	const feedbackTextAreaLong = document.getElementById('feedback_textarea');
    const feedbackTextAreaShort = document.getElementById('feedbackTextAreaShort');
	const charsRemainingLong = document.getElementById('charCountLong');
    const charsRemainingShort = document.getElementById('charCountShort');
	const maxCharactersLong = 1000;
    const maxCharactersShort = 200;
    if (feedbackTextAreaLong) {
        feedbackTextAreaLong.addEventListener('input', () => {
            $(feedbackTextAreaLong).parent().removeClass('has-error');
            const errElm = $(feedbackTextAreaLong).siblings('.feedback-error-message')[0];
            errElm.setAttribute('hidden', '');
            let numOfCharsLong = feedbackTextAreaLong.value.length;
            let counterLong = maxCharactersLong - numOfCharsLong;
            charsRemainingLong.textContent = counterLong + ' characters remaining';
        });
    }
    if (feedbackTextAreaShort) {
        feedbackTextAreaShort.addEventListener('input', () => {
            $(feedbackTextAreaShort).parent().removeClass('has-error');
            const errElm = $(feedbackTextAreaShort).siblings('.feedback-error-message')[0];
            errElm.setAttribute('hidden', '');
            let numOfCharsShort = feedbackTextAreaShort.value.length;
            let counterShort = maxCharactersShort - numOfCharsShort;
            charsRemainingShort.textContent = counterShort + ' characters remaining';
        });
    }
};

const handleYesNos = () => {
    const fields = document.getElementsByClassName('yesOrNoButton');
    for (let i = 0; i < fields.length; i++) {
        const curButton = fields[i];
        const curFieldInput = $(curButton).siblings('#yesNoFeedbackFormInput')[0];
        const errElm = $(curButton).siblings('.feedback-error-message')[0];
        
        curButton.addEventListener('click', function () {
            $(curButton).parent().removeClass('has-error')
            const clickedValue = $(this).val();
            curFieldInput.value = clickedValue;
            $(curButton).addClass('btn-primary');
            $(curButton).removeClass('btn-secondary');
            errElm.setAttribute('hidden', '');

            const otherElements = $(curButton).siblings();
            for (let r = 0; r < otherElements.length; r++) {
                const curElm = otherElements[r];
                if (curElm instanceof HTMLButtonElement) {
                    $(curElm).removeClass("btn-primary")
                    $(curElm).addClass("btn-secondary")
                }
            }
        })
    }
}


const errorTypesText = {
    invalidEmail: 'Please enter a valid email address.',
    required: 'This field is required.',
    requiredState: 'Please select the state your store is located.',
    requiredStore: 'Please select your store location.',
    requiredFeedback: 'Please enter your feedback.',
    requiredRating: 'Please select a rating.',
    tooLong: 'Response is too long.',
    tooShort: 'Please enter the minimum character amount.',
    invalidResponse: 'Please enter a valid response.',
    requiredSelect: 'Please select a response.'
}


// 

// this is the part where it
const submitActualForm = (dataJason) => {
    const base_url = window.location.origin;

    fetch(base_url + '/wcs/resources/store/301/survey', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(dataJason)
    },
    ).then((res) => {
        if (res.status === 200) {
            $('#feedbackTopic').hide();
            const successView = `<div id='feedback_success_content'>
                                    <div id="feedback_success_title">Thank you!</div>
                                    <div id='feedback_success_message'>We appreciate you taking the time to help make your shopping experience the best it can be.</div>
                                    <button class='btn btn-primary btn-block' onclick id="feedback-continue-shopping" >Continue Shopping</button>
                                </div>`;
            let newContentNode = document.createElement('div');
            newContentNode.id = 'responseContent';
            newContentNode.innerHTML = successView;
            let oldContentNode = document.getElementById('feedbackForm');
            oldContentNode.parentNode.replaceChild(newContentNode, oldContentNode);
            listenForContinueShoppingButton();
        } else {
            const errorView = `<div id="feedback_error_message">Something went wrong, please try again.</div>`;
            let newContentNode = document.createElement('div');
            newContentNode.id = 'responseContent';
            newContentNode.innerHTML = errorView;
            let oldContentNode = document.getElementById('feedbackForm');
            oldContentNode.parentNode.replaceChild(newContentNode, oldContentNode);
        }
    })
    .catch(err => {
        const errorView = `<div id="feedback_error_message">Something went wrong, please try again.</div>`;
        let newContentNode = document.createElement('div');
        newContentNode.id = 'responseContent';
        newContentNode.innerHTML = errorView;
        let oldContentNode = document.getElementById('feedbackForm');
        oldContentNode.parentNode.replaceChild(newContentNode, oldContentNode);
        throw(err);
    })

}



const doSomeSafetyChecks = () => {
    let allFieldsAreValid = true;
    let everythingIsOk = true;
   
    // dynamically add error message of choosing from above
    // show error message 
    const addError = (curField, type) => {
        $(curField).parent().addClass('has-error');
        const errElm = $(curField).siblings('.feedback-error-message')[0];
        errElm.innerHTML = errorTypesText[type];
        $(errElm).removeAttr('hidden', '');
    }

    // otherwise remove it slash hide it
    const removeError = (curField) => {
        $(curField).parent().removeClass('has-error');
        const errElm = $(curField).siblings('.feedback-error-message')[0];
        errElm.setAttribute('hidden', '');
    }

    const validateText = (curField, notEmptyAndNeedsVarification, isEmptyAndNeedsVarification) => {
        // need to check email type
        const curFieldType = $(curField).attr("type");

        if (curFieldType === 'email') {
            const tooLong = $(curField).val().length >= 50;
            const tooShort = $(curField).val().length <= 3;
            const includesEmailChars = $(curField).val().includes('@') && $(curField).val().includes('.');
            const isValidEmail = (includesEmailChars) && (!tooShort && !tooLong);
            if (!isValidEmail && notEmptyAndNeedsVarification) {
                if (tooLong) {
                    addError(curField, 'tooLong');
                } else if (tooShort) {
                    addError(curField, 'tooShort');
                } else if (!includesEmailChars) {
                    addError(curField, 'invalidEmail')
                } else {
                    addError(curField, 'invalidEmail')
                }
                allFieldsAreValid = false
            } else {
                removeError(curField)
            }
           
        } else if (notEmptyAndNeedsVarification || isEmptyAndNeedsVarification) {
            const length = $(curField).val().length;
            const maxLength = $(curField).attr('maxLength')
            if (length > maxLength) {
                // add class to field, populate p tag
                addError(curField, 'tooLong')
                allFieldsAreValid = false
            } else if (isEmptyAndNeedsVarification) {
                addError(curField, 'required')
                allFieldsAreValid = false
            } else {
               removeError(curField)
            };
        }
    }

    const validateOption = (curField, notEmptyAndNeedsVarification, isEmptyAndNeedsVarification) => {
        const val = $(curField).val();
        const curFieldType = $(curField).attr("type");

        if (val === null && isEmptyAndNeedsVarification) {
            if (curFieldType === 'state') {
                addError(curField, 'requiredState')
            } else if (curFieldType === 'store') {
                addError(curField, 'requiredStore')
            } else {
                addError(curField, 'requiredSelect')
            }
            allFieldsAreValid = false
        } else {
            removeError(curField)
        }
    }
  
    const validateButtonSelect = (curField, notEmptyAndNeedsVarification, isEmptyAndNeedsVarification) => {
        const val = $(curField).val();
        const curFieldId = $(curField).attr('id');
        if (val.length === 0 && isEmptyAndNeedsVarification) {
            if (curFieldId === 'starRating') {
                addError(curField, 'requiredRating')
            } else if (curFieldId === 'yesNoFeedbackFormInput') {
                addError(curField, 'requiredSelect')
            } else {
                addError(curField, 'required')
            }
            allFieldsAreValid = false;
        } else {
           removeError(curField)
        }
    }

    const chooseValidationType = (curField) => {
        const curFieldID = $(curField).attr('id');
        const curFieldVal = $(curField).val();
        const curFieldIsSelectType = (curField instanceof HTMLSelectElement);
        const notEmptyAndNeedsVarification = ((curFieldVal !== '' && curFieldVal !== null) && (!$(curField).hasClass('meta-data')));
        const isEmptyAndNeedsVarification = (curField.hasAttribute('required') && ((curFieldVal === '' || curFieldVal === null) && (!$(curField).hasClass('meta-data'))));
        const IDs = {
            'feedback_textarea': function () { validateText(curField, notEmptyAndNeedsVarification, isEmptyAndNeedsVarification)},
            'feedbackTextAreaShort': function () { validateText(curField, notEmptyAndNeedsVarification, isEmptyAndNeedsVarification)},
            'feedbackOptionSelect': function () { validateOption(curField, notEmptyAndNeedsVarification, isEmptyAndNeedsVarification)},
            'yesNoFeedbackFormInput':  function () { validateButtonSelect(curField, notEmptyAndNeedsVarification, isEmptyAndNeedsVarification)},
            'starRating':  function () { validateButtonSelect(curField, notEmptyAndNeedsVarification, isEmptyAndNeedsVarification)},
            'feedbackEmailInput':  function () { validateText(curField, notEmptyAndNeedsVarification, isEmptyAndNeedsVarification)},
            'feedbackStoreSelect':  function () { validateOption(curField, notEmptyAndNeedsVarification, isEmptyAndNeedsVarification)},
            'feedbackStateSelect': function () { validateOption(curField, notEmptyAndNeedsVarification, isEmptyAndNeedsVarification)},
        }
        
        if (curFieldIsSelectType) {
            IDs[curFieldID]();
        } else if (notEmptyAndNeedsVarification || isEmptyAndNeedsVarification) {
            IDs[curFieldID]();
        }
    }

    const fields = document.getElementsByClassName('feedback-form-data');

    const formSubmitDataJason =  {
        userMetadata: {
            QuantumMetricSessionID: ''
        },
        answers: {}
    }; 

    const buildFormData = () => {
        let count = 1;

        for (let i = 0; i < fields.length; i++) {
            const field = $(fields[i]);
            const curFieldType = $(field).attr("type");

            if (($(field).hasClass('meta-data'))) {
               const id = $(field).attr('id')
               const value = $(field).val()
               if (id === 'QuantumMetricSessionID') {
                formSubmitDataJason.userMetadata[id] = value;
               } else {
                formSubmitDataJason[id] = value
               }
            } else if (curFieldType !== 'state') {
                const value = $(fields[i]).val()
                formSubmitDataJason.answers[count] = value;
                count++;
            }
        }
        return formSubmitDataJason;
    }

    for (let i = 0; i < fields.length; i++) {
        const curField = fields[i];
        chooseValidationType(curField)
    }

    if (allFieldsAreValid && everythingIsOk) {
        const submitButton = document.getElementById('submit-feedback-form');
        $(submitButton).attr('disabled', true)
        submitActualForm(buildFormData());
    } 

}


const handleSubmitButton = () => {
    const submitButton = document.getElementById('submit-feedback-form');
    submitButton.addEventListener('click', function (e) {
        e.preventDefault()
        doSomeSafetyChecks()
    })
}




export { postPurchaseModal };
